<script setup lang="ts">
import Header from '~/layouts/-components/Header.vue';
import Footer from '~/layouts/-components/Footer.vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const isExcludedPath = (path: string, excludedKeywords: string[]) => {
  return excludedKeywords.some(keyword => path.includes(keyword));
};
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <Header/>
    <Transition name="page">
      <main class="page-main bg-gray-light flex-1 flex flex-col relative">
        <slot></slot>
        <FloatingCTA :static="false" v-if="!isExcludedPath(route.path, ['bli-kund', 'finish', 'fullmakt', 'integritetspolicy', 'villkor', 'byt-kon'])" />
      </main>
    </Transition>
    <Footer />
  </div>
</template>

<style  lang="scss">
.page-enter-active,
.page-leave-active {
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
